import { useTranslation } from "react-i18next";
import { FileText, Scale, Shield, Lock, CheckCircle } from "lucide-react";

const TrustComplianceSection = () => {
  const { t } = useTranslation();

  const areas = [
    {
      icon: FileText,
      titleKey: "trustCompliance.areas.socialSecurity.title",
      descriptionKey: "trustCompliance.areas.socialSecurity.description"
    },
    {
      icon: Scale,
      titleKey: "trustCompliance.areas.taxLaw.title",
      descriptionKey: "trustCompliance.areas.taxLaw.description"
    },
    {
      icon: Shield,
      titleKey: "trustCompliance.areas.dutyCare.title",
      descriptionKey: "trustCompliance.areas.dutyCare.description"
    },
    {
      icon: Lock,
      titleKey: "trustCompliance.areas.dataSecurity.title",
      descriptionKey: "trustCompliance.areas.dataSecurity.description"
    }
  ];

  const badges = [
    { label: "GDPR", icon: CheckCircle },
    { label: "ISO 27001", icon: CheckCircle },
    { label: "SOC 2", icon: CheckCircle }
  ];

  return (
    <section className="py-24 px-4 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-primary/10 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-bold mb-4">
            {t('trustCompliance.title')}
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            {t('trustCompliance.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-16">
          {areas.map((area, index) => (
            <div 
              key={index} 
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300"
            >
              <div className="w-12 h-12 bg-primary/20 rounded-xl flex items-center justify-center mb-4">
                <area.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-semibold text-lg mb-2 text-white">
                {t(area.titleKey)}
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed">
                {t(area.descriptionKey)}
              </p>
            </div>
          ))}
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap justify-center gap-6">
          {badges.map((badge, index) => (
            <div 
              key={index}
              className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20"
            >
              <badge.icon className="h-5 w-5 text-green-400" />
              <span className="font-semibold text-white">{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustComplianceSection;
